import { Component, inject } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICON } from '../../constants/icons.constant';
import { SidebarService } from '../../services/local/sidebar.service';
import { LanguagePickerComponent } from '../language-picker/language-picker.component';
import { ThemePickerComponent } from '../theme-picker/theme-picker.component';

@Component({
  selector: 'immo-sidebar',
  imports: [
    ThemePickerComponent,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatRippleModule,
    LanguagePickerComponent
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css',
})
export class SidebarComponent {

  // -----------------------------------------------------------------------------------------------------
  // @ DEPENDENCIES
  // -----------------------------------------------------------------------------------------------------

  private readonly sidebarService = inject(SidebarService);

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC INSTANCE PROPERTIES
  // -----------------------------------------------------------------------------------------------------

  readonly isExpanded = this.sidebarService.isExpanded;

  readonly ICON = ICON;

  // -----------------------------------------------------------------------------------------------------
  // @ PUBLIC METHODS
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle the sidebar.
   * 
   * @returns {void}
   */
  toggle(): void {
    this.sidebarService.toggle();
  }
}
